import React, { Component } from "react";
import PropTypes from "prop-types";
import { injectIntl, intlShape } from "react-intl";
import { connect } from "react-redux";
import { compose } from "ramda";
import { ClientLogo } from "@cxagroup/casper";
import { Card, CardSection } from "cxa-components";
import { getToday } from "cxa-utils";
import ForgotPasswordForm from "./ForgotPasswordForm";
import messages from "../messagesDescription";
import { forgotPassword, clean } from "../../actions/forgotPasswordActions";
import { fetchPasswordPolicy } from "../../actions/changePasswordActions";
import LogoPP from "../common/LogoPP";

import GlobalMessageBoard from "../common/global-message-board";
class ForgotPassword extends Component {
  componentDidMount() {
    const { clientName, fetchPasswordPolicy } = this.props;

    fetchPasswordPolicy({ clientName });
  }

  componentWillUnmount() {
    this.props.clean();
  }

  render() {
    const { client, logoUrl, forgotPassword, intl, dateOfBirth, push } = this.props;

    return (
      <div>
        <div
          style={{
            backgroundColor: "pink",
            position: "sticky",
            left: "0",
            top: "0",
            zIndex: "100",
          }}
        >
          <GlobalMessageBoard />
        </div>
        <div className="login-wrapper">
          <Card>
            <header>
              {logoUrl ? (
                <ClientLogo client={client} logoUrl={logoUrl} size="large" />
              ) : (
                <LogoPP width={240} />
              )}
              <h3>{intl.formatMessage(messages.passwordResetDescription)}</h3>
            </header>
            <section>
              <p>{intl.formatMessage(messages.enterIdDescription)}</p>
              <p>{intl.formatMessage(messages.validateDescription)}</p>
            </section>
            <CardSection>
              <ForgotPasswordForm
                onSubmit={forgotPassword}
                onCancel={() => push("/")}
                dateOfBirth={dateOfBirth}
                {...this.props}
              />
            </CardSection>
          </Card>
        </div>
      </div>
    );
  }
}

ForgotPassword.propTypes = {
  clean: PropTypes.func.isRequired,
  push: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
  forgotPassword: PropTypes.func.isRequired,
  client: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  logoUrl: PropTypes.string,
  loginLabel: PropTypes.string,
  clientName: PropTypes.string,
  dateOfBirth: PropTypes.bool,
  fetchPasswordPolicy: PropTypes.func,
};

ForgotPassword.defaultProps = {
  dateOfBirth: false,
  fetchPasswordPolicy: function() {},
};

const mapStateToProps = ({
  app: { client, clientName },
  common: { logoUrl, clientSettings },
  forgotPassword: { response, submitting, submitted },
  changePassword: { dateOfBirth },
}) => ({
  client,
  logoUrl,
  response,
  submitting,
  submitted,
  dateOfBirth,
  clientName,
  maxDate: getToday(),
  initialValues: {
    companyId: clientName,
  },
  loginLabel: clientSettings ? clientSettings.loginLabel : null,
});

const mapDispatchToProps = {
  forgotPassword,
  fetchPasswordPolicy,
  clean,
};

const ForgotPasswordContainer = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(ForgotPassword);

export default ForgotPasswordContainer;



// WEBPACK FOOTER //
// ./components/password/ForgotPasswordContainer.js